/* The deadline always includes an explicit UTC offset; visitor time zones never change it. */
if (!customElements.get('bb-preorder-countdown')) {
  customElements.define('bb-preorder-countdown', class extends HTMLElement {
    connectedCallback() {
      this.timer = null;
      const raw = (this.dataset.opensAt || '').trim();
      this.deadline = Date.parse(raw);
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(raw) || !Number.isFinite(this.deadline)) {
        if (raw) {
          this.querySelector('[data-upcoming]').hidden = true;
          const warning = this.querySelector('[data-date-error]');
          if (warning) warning.hidden = false;
        }
        return;
      }
      const dateLabel = this.querySelector('[data-launch-date]');
      if (dateLabel && dateLabel.textContent.trim() === raw) {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short', timeZone: this.dataset.timeZone || 'America/Denver' };
        try {
          dateLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', options).format(this.deadline);
        } catch (_) {
          dateLabel.textContent = new Intl.DateTimeFormat('en', { ...options, timeZone: 'UTC' }).format(this.deadline);
        }
      }
      this.tick = () => {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const open = remaining === 0;
        this.querySelector('[data-upcoming]').hidden = open;
        this.querySelector('[data-open]').hidden = !open;
        this.querySelector('[data-countdown]').hidden = open;
        if (open) {
          clearInterval(this.timer);
          this.timer = null;
          return;
        }
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
        Object.entries(values).forEach(([unit, value]) => { this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0'); });
      };
      this.onVisibility = () => {
        clearInterval(this.timer);
        this.timer = null;
        if (!document.hidden) {
          this.tick();
          if (Date.now() < this.deadline) this.timer = setInterval(this.tick, 1000);
        }
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onVisibility();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
